export default {
  switchAccount: "Zmień konto",
  login: "Zaloguj",
  loginFirst: "Zaloguj się do swojego konta",
  start: "Start",
  hasHistory: "Na niektóre pytania już udzielono odpowiedzi.",
  loadHistory: "Chcesz kontynuować?",
  cancel: "Nie",
  confirm: "Tak",
  contact: "Zostaw swoje dane kontaktowe i zdobądź szansę na wygraną!",
  completed: "Ukończyłeś ankietę!",
  leaveMessage: "Zostaw swoje dane kontaktowe i zdobądź szansę na wygraną!",
  enterEmail: "E-mail:",
  enterPhone: "Telefon:",
  submit: "Prześlij",
  leave: "Wyjdź",
  submitted: "Przesłano",
  thanks: "Dziękuję!",
  opinion: "Jaka jest Twoja opinia?",
  prev: "Poprzednie",
  next: "Następne",
  unlikely: "Mało prawdopodobne",
  likely: "Bardzo prawdopodobne",
  claimYourRewards: "Możesz odebrać swoje nagrody.",
  rewardSent: "Wysłano nagrody.",
  checkInGame: "Odbierz to w grze.",
  copy: "Kopiuj",
  copied: "Skopiowano!",
  selectTips: "Wybierz najtrafniejszą odpowiedź.",
  multipleTips: "Możesz wybrać kilka odpowiedzi.",
  leastChoose: "Wybierz do xxx odpowiedzi",
  maxChoose: "Wybierz co najmniej xxx odpowiedzi.",
  mustAnswer: "Odpowiedz najpierw na obecne pytanie.",
  mustWrite: "Podziel się opinią.",
  checkEmail: "Wpisz prawidłowy adres e-mail.",
  checkPhone: "Wpisz prawidłowy numer telefonu.",
  isAnswer: "Już zrobiłeś tą ankietę",
  unStart: "Wydarzenie niedostępne",
  end: "Wydarzenie jest zakończone",
  server: "Wybierz serwer",
  role: "Wybierz postać",
  common: "System jest zajęty. Proszę spróbować ponownie później.",
  title: "Ankieta",
  titleAward: "Ankieta",
  leastWord: "Wpisz co najmniej xxx znaków.",
  maxWord: "Przekroczono limit znaków (xxx)!",
  singleChoose: "Odpowiedź pojedyncza",
  multiChoose: "Odpowiedź wielokrotna",
  matrix: "Pytanie Matrix",
  score: "Ocena",
  textLimit: "(xx-yyy znaków)",
  coverGiftTitle: "Wypełnij ankietę, aby odebrać prezent",
  "-20001": "Nie zalogowano",
  "-20002": "Brak wymaganych parametrów",
  "-20003": "Ankieta nie znaleziona",
  "-20004": "Konfiguracja ankiety w toku",
  "-20005": "Ankieta zatrzymana",
  "-20006": "Wydarzenie ankiety nie rozpoczęte",
  "-20007": "Wydarzenie ankiety zakończone",
  "-20008": "Już odpowiedziano",
  "-20010": "Dystrybucja nagrody nie powiodła się",
  "-20011": "Nagroda za tę ankietę już została rozdystrybuowana",
  "-20012": "Jeszcze nie odpowiedziano",
  "-20016": "Nieprawidłowy identyfikator gry",
};
